import React from "react";
import CommunityComponents from "../HomePage/Community";
import Style from '../Styles/Common.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";

const CommunityPage = ()=>{
    return(
        <div>
            <BreadcrumbComponent home='Home' listOne="Community" />
            <div className={Style.pageTitle + ' ' + Style.communityPag}>
                <CommunityComponents />
            </div>
        </div>
    )
}

export default CommunityPage;